import { OrderTechrulePipe } from 'src/shared/pipes/orderByTechrules.pipe';
export class FieldSort {
  private orderByPipe: OrderTechrulePipe = new OrderTechrulePipe();

  private sorting = {
    prop: '',
    reverse: true,
  };

  SortField(fieldName: string, list: any[]): any[] {
    if (!fieldName || fieldName === '') {
      return;
    }

    if (this.sorting.prop === fieldName) {
      this.sorting.reverse = !this.sorting.reverse;
    } else {
      this.sorting.prop = fieldName;
      this.sorting.reverse = true;
    }

    return this.orderByPipe.transform(
      list,
      this.sorting.reverse ? `-${this.sorting.prop}` : this.sorting.prop,
    );
  }
}
